import {useState} from "react";
import {DevicePhoneMobileIcon} from "@heroicons/react/20/solid";
import {OtsForm, OtsFormActions, OtsFormSection} from "../components/OtsForm";
import {OtsTextArea} from "../components/OtsTextInput";

export type AppAccessSmsDeliveryFormProps = {
  isSending?: boolean;
  disabled?: boolean;
  onSend: (recipients: string[], message?: string) => boolean | Promise<boolean>;
};

/** Directed SMS delivery form. Phone numbers are normalized and validated by the server. */
export const AppAccessSmsDeliveryForm = ({
  isSending = false,
  disabled = false,
  onSend,
}: AppAccessSmsDeliveryFormProps) => {
  const [recipients, setRecipients] = useState("");
  const [message, setMessage] = useState("");

  const submit = async () => {
    const parsedRecipients = recipients.split(/[;,\n]+/).map((value) => value.trim()).filter(Boolean);
    if (parsedRecipients.length === 0) return;
    if (await onSend(parsedRecipients, message || undefined)) {
      setRecipients("");
      setMessage("");
    }
  };

  return (
    <OtsForm
      aria-label="Text setup"
      density="compact"
      onSubmit={() => void submit()}
      actions={<OtsFormActions submitLabel="Send setup text" submitIcon={<DevicePhoneMobileIcon/>} submitting={isSending} submitDisabled={disabled}/>}>
      <OtsFormSection title="Text setup" description="Send the branded setup link directly by SMS. Credential links remain private and short-lived.">
        <OtsTextArea
          label="Recipient phone numbers"
          description="Enter one number per line, or separate numbers with commas or semicolons."
          rows={2}
          inputMode="tel"
          placeholder={"+1 555 555 0100\n+1 555 555 0101"}
          value={recipients}
          onChange={(event) => setRecipients(event.currentTarget.value)}
          disabled={disabled}
          required
          size="compact"/>
        <OtsTextArea
          label="Optional message"
          rows={2}
          maxLength={500}
          value={message}
          onChange={(event) => setMessage(event.currentTarget.value)}
          disabled={disabled}
          size="compact"/>
      </OtsFormSection>
    </OtsForm>
  );
};
